import type { FaireThemeEntity } from "../../entity_types/theme";

export const rustic_depot_cozy_cabin_candles_jar_rustic_vessels: FaireThemeEntity =
  {
    token: "rustic-depot-cozy-cabin-candles-jar-rustic-vessels",
    type: "theme",
    retailerToken: "r_464eox2tas",
    name: "Cozy Cabin Candles",
    description:
      "Warm, woodsy candles in rustic vessels that fit your cabin-cozy brand",
    bgColor: "#E8D5C4",
    tileBgColor: "#7e5733",
    productTokens: [
      "p_y6c6r46bes",
      "p_4qyzzm2tfv",
      "p_eskzehpg",
      "p_wakdtz4x8r",
      "p_rmcp88j5zw",
      "p_4m2nun76sq",
      "p_f727ru8d46",
      "p_ztd8jrk2b3",
      "p_3tsy467maz",
      "p_depfnyqvzp",
      "p_c6457xt61l",
      "p_mcc6v37qhx",
      "p_beafaxh6kz",
      "p_7zpk6kej99",
      "p_764jd2hz8l",
      "p_vhbmubd4kg",
      "p_pjzga8zj8q",
      "p_dz44i1aiof",
      "p_h2kmzwush4",
      "p_mpezqay46y",
      "p_4hf9zambpa",
      "p_bnzz29nrxi",
      "p_4v6fgue0zf",
      "p_6qcb4w6lan",
      "p_dbkvx5i14c",
      "p_9r0wmyqt",
      "p_vuuxsd3chx",
      "p_m3kaxjr6s2",
      "p_9vxn7dbzyx",
      "p_xm8kf92nm8",
      "p_fvkhtpndrq",
      "p_dbansnjogh",
      "p_98d8jfkwjd",
    ],
    exactProducts: true,
    meta: {
      source: "mock",
      importedAt: "2026-03-24T13:50:10Z",
      importedBy: "retailer-themes-entity-migration",
    },
  };
